// extracted by mini-css-extract-plugin
export default {"container":"AddApplication-AddApplication__container--sr7ZK","select":"AddApplication-AddApplication__select--Gb9CP","closeBtn":"AddApplication-AddApplication__closeBtn--r_k5b"};